import React, { useEffect, useState } from 'react';
import MultipleListField from 'views/MultipleListField.js';
import Request from 'files/Request.js';
import Views from 'views/Main.js';

const InstructionsList = ({ excludeCategories = [], excludeIDs = [], onChange, utils, value }) => {

    const [instructions, setInstructions] = useState([]);
    const [values, setValues] = useState([]);

    const onSelectionChange = items => {

        // prepare list of ids for selection and update local state with selected targets
        let ids = items.map(item => item.id);
        let next = instructions.filter(instruction => ids.includes(instruction.id));
        setValues(next);

        // notify subscriberes of data change
        if(typeof(onChange) === 'function') {
            onChange(next);
        }
    }

    const getInstructions = () => {
        return instructions.filter(instruction => {
            return excludeIDs?.includes(instruction.id) !== true && excludeCategories?.includes(instruction.category) !== true;
        }).map(instruction => ({
            id: instruction.id,
            title: instruction.name
        }));
    }

    const getValues = () => {
        return values.map(instruction => ({
            id: instruction.id,
            title: instruction.name
        }));
    }

    const fetchInstructions = async () => {
        try {

            // submit request to server
            let { trigger_instructions } = await Request.get(utils, '/users/', {
                type: 'trigger_instructions'
            });
            setInstructions(trigger_instructions);

        } catch(e) {
            utils.alert.error({
                error: e,
                message: `There was an issue retrieving your instructions list. ${e.message || 'An unknown error occurred'}`,
                origin: 'instructions_list.fetch_instructions'
            });
        }
    } 

    useEffect(() => {
        if(instructions?.length > 0) {
            setValues(instructions.filter(instruction => value?.includes(instruction.id)));
        }
    }, [instructions, value]);

    useEffect(() => {
        fetchInstructions();
    }, []);
    
    return (
        <MultipleListField
        items={getInstructions()}
        onChange={onSelectionChange}
        onRenderResult={(item, index, items, onRemoveItem) => {
            return (
                <div key={index}>
                    {Views.row({
                        bottomBorder: index !== items.length - 1,
                        hideOnClickArrow: true,
                        label: item.title,
                        value: (
                            <img
                            className={'text-button'}
                            onClick={onRemoveItem.bind(this, index)}
                            src={'images/delete-red-icon.png'}
                            style={{
                                height: 20,
                                objectFit: 'contain',
                                width: 20
                            }} />
                        )
                    })}
                </div>
            )
        }}
        value={getValues()} />
    )
}

export default InstructionsList;
